import { Country } from '../enums';

export interface ConstructionPeriod {
    min: number | null;
    max: number | null;
    value: number | null;
}

// TODO: Find a way to re-use this same list on front-end and on back-end
export const CONSTRUCTION_PERIODS_PER_COUNTRY: Record<Country, Array<ConstructionPeriod>> = {
    [Country.Austria]: [],
    [Country.Belgium]: [
        {
            min: null,
            max: 1870,
            value: 1870,
        },
        {
            min: 1871,
            max: 1913,
            value: 1892,
        },
        {
            min: 1914,
            max: 1944,
            value: 1929,
        },
        {
            min: 1945,
            max: 1969,
            value: 1957,
        },
        {
            min: 1970,
            max: 1979,
            value: 1975,
        },
        {
            min: 1980,
            max: 1989,
            value: 1985,
        },
        {
            min: 1990,
            max: 1999,
            value: 1995,
        },
        {
            min: 2000,
            max: 2009,
            value: 2005,
        },
        {
            min: 2010,
            max: null,
            value: 2015,
        },
        {
            // I don't know
            value: null,
            min: null,
            max: null,
        },
    ],
    [Country.France]: [
        {
            min: null,
            max: 1870,
            value: 1870,
        },
        {
            min: 1871,
            max: 1913,
            value: 1892,
        },
        {
            min: 1914,
            max: 1944,
            value: 1929,
        },
        {
            min: 1945,
            max: 1969,
            value: 1957,
        },
        {
            min: 1970,
            max: 1979,
            value: 1975,
        },
        {
            min: 1980,
            max: 1989,
            value: 1985,
        },
        {
            min: 1990,
            max: 1999,
            value: 1995,
        },
        {
            min: 2000,
            max: 2009,
            value: 2005,
        },
        {
            min: 2010,
            max: null,
            value: 2015,
        },
        {
            // I don't know
            value: null,
            min: null,
            max: null,
        },
        // TODO: These next are Meilleurs Agents ones. We need to decide if we want to use them or
        //  not https://kugawana.slack.com/archives/C06178DEJBX/p1725892895720279
        // {
        //     min: null,
        //     max: 1850,
        //     value: 1850,
        // },
        // {
        //     min: 1850,
        //     max: 1913,
        //     value: 1851,
        // },
        // {
        //     min: 1914,
        //     max: 1947,
        //     value: 1915,
        // },
        // {
        //     min: 1948,
        //     max: 1969,
        //     value: 1949,
        // },
        // {
        //     min: 1970,
        //     max: 1980,
        //     value: 1971,
        // },
        // {
        //     min: 1981,
        //     max: 1991,
        //     value: 1982,
        // },
        // {
        //     min: 1992,
        //     max: 2000,
        //     value: 1993,
        // },
        // {
        //     min: 2001,
        //     max: 2010,
        //     value: 2002,
        // },
        // {
        //     min: 2011,
        //     max: null,
        //     value: 2012,
        // },
        // {
        //     // I don't know
        //     value: null,
        //     min: null,
        //     max: null,
        // },
    ],
    [Country.Germany]: [
        {
            min: null,
            max: 1870,
            value: 1870,
        },
        {
            min: 1871,
            max: 1913,
            value: 1892,
        },
        {
            min: 1914,
            max: 1944,
            value: 1929,
        },
        {
            min: 1945,
            max: 1969,
            value: 1957,
        },
        {
            min: 1970,
            max: 1979,
            value: 1975,
        },
        {
            min: 1980,
            max: 1989,
            value: 1985,
        },
        {
            min: 1990,
            max: 1999,
            value: 1995,
        },
        {
            min: 2000,
            max: 2009,
            value: 2005,
        },
        {
            min: 2010,
            max: null,
            value: 2015,
        },
        {
            // I don't know
            value: null,
            min: null,
            max: null,
        },
    ],
};
